<template>
    <div class="">
        <h4 class="atlhr-dashboard-title mt-10">Company Dashboard<span>{{companyname}} / Dashboard</span></h4>
     
        <div>
            <div class="row trz_dashboard" style="margin-top: 0;">
                <div class="p-0 col-12">
                        <div class="clearfix pt-0 d-flex card border-0 no-shadow bg-wash" >
                                <div class="row p-2  pl-4 pr-4">
                                    <div class="col-sm-12 row m-0 py-0 px-0 d-links ">
                                        
                                            <div class="p-0  company-dashboard-items-wrapper col-2">
                                                <div class="border rounded clearfix w-30 m-2 company-dashboard-items-2 pb-2 px-4 pt-4 d-flex align-items-center card justify-content-center" :class="{'error-found': employee_err}">
                                                    <img v-if="employee_err" v-bind:src="$api_url+'/images/alert-xxl.png'"  class="img-fluid mb-2 company-dashboard-tooltip" width="25px" title="Looks like you have not added any employee yet" v-b-tooltip.left.hover="{ customClass: '' }"/>
                                                    
                                                    <div class='employee-count'>{{companyemployees}}</div>
                                                    <a  class="text-decoration-none btn btn-default text-center w-100 p-0">
                                                        
                                                        <div class=" text-center"><p style="font-size:1rem;line-height: 1.5;">Total employees</p ></div>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="p-0  company-dashboard-items-wrapper col-2">
                                                <div class="border rounded clearfix w-30 m-2 company-dashboard-items-2 pb-2 px-4 pt-4 d-flex align-items-center card justify-content-center" :class="{'error-found': employee_err}">
                                                    <img v-if="employee_err" v-bind:src="$api_url+'/images/alert-xxl.png'"  class="img-fluid mb-2 company-dashboard-tooltip" width="25px" title="Looks like you have not added any employee yet" v-b-tooltip.left.hover="{ customClass: '' }"/>
                                                    <div class='employee-count'>{{activeemployees}}</div>
                                                    <a  class="text-decoration-none btn btn-default text-center w-100 p-0">
                                                        <div class=" text-center"><p style="font-size:1rem;line-height: 1.5;">Active employees</p ></div>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="p-0  company-dashboard-items-wrapper col-2">
                                                <div class="border rounded clearfix w-30 m-2 company-dashboard-items-2 pb-2 px-4 pt-4 d-flex align-items-center card justify-content-center" :class="{'error-found': employee_err}">
                                                    <img v-if="employee_err" v-bind:src="$api_url+'/images/alert-xxl.png'"  class="img-fluid mb-2 company-dashboard-tooltip" width="25px" title="Looks like you have not added any employee yet" v-b-tooltip.left.hover="{ customClass: '' }"/>
                                                    <a :href="$api_url+'/employee'" class="text-decoration-none btn btn-default text-center w-100 p-0">
                                                        <img v-bind:src="$api_url+'/images/Employee-d.png'"  class="img-fluid mb-2" width="45px" />
                                                        <div class=" text-center"><p style="font-size:1rem;line-height: 1.5;">Employees</p ></div>
                                                    </a>
                                                </div>
                                            </div>

                                            <div class="p-0 company-dashboard-items-wrapper col-2" v-if="addons.includes('Pf')">
                                                <template v-if="addons.includes('Pf')">
                                                    <div class="border rounded clearfix w-30 m-2 company-dashboard-items-2 pb-2 px-4 pt-4 d-flex align-items-center card justify-content-center" :class="{ 'error-found': notice_err }">
                                                        <img v-if="notice_err" v-bind:src="$api_url+'/images/alert-xxl.png'"  class="img-fluid mb-2 company-dashboard-tooltip" width="25px" title="Notices Error" v-b-tooltip.left.hover="{ customClass: '' }"/>
                                                        <a :href="$api_url+ '/pf/home'" class="text-decoration-none btn btn-default text-center w-100 p-0">
                                                            <img v-bind:src="$api_url+'/images/Doc.png'"  class="img-fluid mb-2 d-none" width="45px" />
                                                            <img v-bind:src="$api_url+'/images/pf-d.png'"  class="img-fluid mb-2" width="45px" />
                                                            <div class=" text-center"><p style="font-size:1rem;line-height: 1.5;">Provident Fund</p></div>
                                                        </a> 
                                                    </div>
                                                </template>                  
                                            </div> 
                                            <div class="p-0 company-dashboard-items-wrapper col-2" v-if="addons.includes('Gf')">
                                                <template v-if="addons.includes('Gf')">
                                                    <div class="border rounded clearfix w-30 m-2 company-dashboard-items-2 pb-2 px-4 pt-4 d-flex align-items-center card justify-content-center" :class="{ 'error-found': notice_err }">
                                                        <img v-if="notice_err" v-bind:src="$api_url+'/images/alert-xxl.png'"  class="img-fluid mb-2 company-dashboard-tooltip" width="25px" title="Notices Error" v-b-tooltip.left.hover="{ customClass: '' }"/>
                                                        <a :href="$api_url+ '/gf/home'" class="text-decoration-none btn btn-default text-center w-100 p-0">
                                                            <img v-bind:src="$api_url+'/images/Doc.png'"  class="img-fluid mb-2 d-none" width="45px" />
                                                            <img v-bind:src="$api_url+'/images/gf-d.png'"  class="img-fluid mb-2" width="45px" />
                                                            <div class=" text-center"><p style="font-size:1rem;line-height: 1.5;">Gratuity Fund</p></div>
                                                        </a> 
                                                    </div>
                                                </template>                  
                                            </div> 
                                            

                                    </div>
                                    
                                </div>     
                            </div>
                    </div>
            </div>

            
            <!-- <div class="row " style="margin-top: 25px;">
                <div class="col-6 p-1 pl-0">
                    <div class="card bar_fiscal_year h-100" >

                        <div class="card bar_fiscal_year dash_pf" >   
                            <template>
                                <h5 class="pt-2 text-center title">Major Payroll Movement</h5>
                                <lock-template :pageurl="$api_url"></lock-template>
                            </template>
                                    
                        </div>


                    </div>
                </div>
                <div class="col-6 p-1 pr-0">
                    <div class="card bar_fiscal_year dash_pf" >   
                    <template>
                        <h5 class="pt-2 text-center title">Payroll Quick Stat</h5>  
                        <lock-template :pageurl="$api_url"></lock-template>
                    </template>
                            
                    </div>                 
                </div>
                
            </div>
            <div class="row " style="margin-top: 25px;">
                <div class="col-8 p-1 pl-0">
                    

                    <div class="card bar_fiscal_year dash_pf" >   
                        <template>
                            <h5 class="pt-2 text-center title">Payroll Run Status</h5>  
                            <lock-template :pageurl="$api_url"></lock-template>
                        </template>
                    </div>             

                </div>
                <div class="col-4 p-1 pr-0">
                    <div class="card bar_fiscal_year dash_pf" >   
                        <template>
                            <h5 class="pt-2 text-center title">Payroll Breakup</h5> 
                                <lock-template :pageurl="$api_url"></lock-template>
                        </template>
                                
                    </div>                 
                </div>
                
            </div>


            <div class="row " style="margin-top: 25px;">
                <div class="col-4 p-1 pl-0 text-right">
                    <div class="card bar_fiscal_year h-100 dash_pf" >
                        <h5 class="pt-2 text-center title">Compliance Summary</h5> 
                        <lock-template :pageurl="$api_url"></lock-template>
                    </div>
                        
                </div>
            
                <div class="col-8 p-1 pr-0">
                    <div class="card bar_fiscal_year dash_pf" >   
                        <h5 class="pt-2 text-center title">Joiners and Leavers</h5>  
                        <template>
                                <lock-template :pageurl="$api_url"></lock-template>
                        </template>
                                    
                    </div>                 
                </div>
                
            </div>


            
            <div class="row " style="margin-top: 25px;">
                <div class="col-6 p-1 pl-0 text-right">
                    <div class="card bar_fiscal_year dash_pf">
                        <h5 class="pt-2 text-center title">List of Approved Holidays</h5>
                        
                        <template>
                                <lock-template :pageurl="$api_url"></lock-template>
                        </template>
                    </div>
                </div>
                <div class="col-6 p-1 pr-0">

                    <div class="card bar_fiscal_year dash_pf" >   
                        <h5 class="pt-2 text-center title">On Leave Today</h5>  
                        <template>
                                <lock-template :pageurl="$api_url"></lock-template>
                        </template>
                                
                    </div>            
                </div>
            </div> -->
                    
                
            
        </div>
        <!-- <div v-else>

            <lock-template :pageurl="$api_url"></lock-template>
            
        </div> -->

    </div>
</template>


  

<script>
    
  /*

    import LineChart from '../LineChart.js';
    import BarChart from '../BarChart.js';
    import DoughnutChart from '../DoughnutChart.js';
    import PolarChart from '../PolarChart.js';
    import RadarChart from '../RadarChart.js';

  */

    import moment from 'moment';
    import { Carousel3d, Slide } from 'vue-carousel-3d';
    export default{

        props: ['pageurl'], 
    
        components: {
            Carousel3d,
            Slide
        },     
        data(){            
            
            return {
                
                datacollection: null,
                doughnutDatas: null,
                linedDatas: null,
                barDatas: null,
                barDatasOpposite:null,
                polarDatas: null,
                radarDatas: null,
                barFiscalYearDatas: null,
                options:null,
                options2:null,
                options3:null,
                options_line:null,
                options_doughnut:null,
                myStyles:null,
                myStyles2:null,
                myStyles3:null,
                myStyles_line:null,
                myStyles_doughnut:null,
                fdata: [],

                cu:window.location.href,
                ce:false, 
                pageUrl:this.$api_url,
                company_id:0,
                companyname:'',                
                companyaddress:'',              
                companyemployees:'',            
                activeemployees:'',            
                companyphone:'',
                companyemail:'',
                companycontactperson:'',
                companycity:'',
                companyzip:'',
                logosrc:null,

                overview_err : false,
                employee_err : false,
                leave_attendance_err : false,
                document_err : false,
                report_err : false,
                compliance_err : false,
                notice_err : false,
                payroll_err : false,
                chalan_err : false,

                addons : [],

                employees : [], 
                payrunsapproved:[],
                paginationapproved: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
                search:{employee_id:'', pay_slip_name:'', pay_slip_ref:'', fiscal_year:'', month:''},
                per_pageapproved:10,

                payrunsfiscalyear: [], 

                payrunsfiscalmonth: [],
                payrunsapproveddoughnut: [],
                payrunsapproveddoughnut2: [],
                search_doughnut:{employee_id:'', pay_slip_name:'', pay_slip_ref:'', fiscal_year:'', month:''},
                search_join:{ fiscal_year:''},

                dashboardTotals: [],

                doughnut_loader:false,
                quick_start_load:false,
                load_data:'Please hold tight! We are generating your payroll stat!',

                year_segment1:'',
                year_segment2:'',
                payrun_count:0,

                payrunsdraft: [],
                draft_payruns:[],
                doughnut_length:0,
                loan_settings: '',
                joinermonth:[],

                joining_data:[],
                holidays:[],
                joining_options_line:[],
                lineJoiningDatas:null,


                /***** background color
                  'rgba(63, 81, 181, 0.5)',
                  'rgba(77, 182, 172, 0.5)',
                  'rgba(66, 133, 244, 0.5)',
                  'rgba(156, 39, 176, 0.5)',
                  'rgba(233, 30, 99, 0.5)',

                ***/


            }
        },
        methods:{
            
            formatdate:function(x) 
            {
                return moment(x).format('MMMM YYYY');
            },

            formatdate2:function(x) 
            {
                return moment(x).format('D');
            },

            fillData () {

                
                

                
                this.datacollection = {
                  labels: [this.getRandomInt(), this.getRandomInt()],
                  datasets: [
                    {
                      label: 'Data One',
                      backgroundColor: 'rgba(63, 81, 181, 0.5)',
                      data: [this.getRandomInt(), this.getRandomInt()]
                    }, {
                      label: 'Data Two',
                      backgroundColor: 'rgba(77, 182, 172, 0.5)',
                      data: [this.getRandomInt(), this.getRandomInt()]
                    }
                  ]
                }
              },
            getRandomInt () {
                return Math.floor(Math.random() * (50 - 5 + 1)) + 5
            },

            doughnutData(basic_salary,house_rent,conveyance_allowance,medical_allowance,total_additions,pf_contribution){
                this.doughnutDatas = {
                  labels: ['Basic Salary', 'House Rent Allowance' ,'Conveyance Allowance'  ,'Medical Allowance' , 'Other Variable Pay', 'PF Contribution (Employer)'],           
                  datasets: [{
                    label: 'My First Dataset',
                    data: [basic_salary,house_rent,conveyance_allowance,medical_allowance,total_additions,pf_contribution],
                    backgroundColor: [
                        'rgba(66, 133, 244, 0.5)',
                        'rgba(156, 39, 176, 0.5)',
                        'rgba(63, 81, 181,0.5)',
                        'rgba(127,54,121,0.5)',                        
                        'rgba(77, 182, 172,0.5)',
                    ],
                    hoverOffset: 4
                  }]
                };

                 this.options_doughnut= {
                    tooltips: {
                      callbacks: {
                        
                        label: function(tooltipItem, data) {
                         
                          var label  = data['labels'][tooltipItem['index']];
                          var value = data['datasets'][0]['data'][tooltipItem['index']];
                          
                          return label +'  '+Number(value).toLocaleString();
                        },
                       
                      },
                      
                    }
                    
                    
                };

                this.myStyles_doughnut={
                    height: '100%',
                    width: '100%',
                    position: 'relative',

                };
            },
            getHoliDays:function() 
            {   
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/holidays' , {
                    params: {
                        current_month: 1
                    }
                }).then(function(response){
                    
                    if(response.data.length != 0)
                    {
                        //console.log( response.data);
                        this.holidays = response.data.holidays;
                    }       
                    
                }.bind(this));

                this.$bvModal.hide('bv-modal-govt-holiday');

            },

            barData(){
                this.barDatas={

                    labels: ['Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing'],
                    datasets: [
                        {
                            label: 'Male',
                            data: [10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30],
                            
                            borderColor: 'rgba(77, 182, 172, 0.5)',
                            backgroundColor:'rgba(77, 182, 172, 0.2)',
                            borderWidth: 1
                        },
                         {
                            label: 'Female',
                            data: [13,23,33,13,23,33,13,23,33,13,23,33,13,23,33,13,23,33,13,23,33,13,23,33,13,23,33,13,23,33], 
                            borderColor: 'rgba(66, 133, 244, 0.5)',
                            backgroundColor:'rgba(66, 133, 244, 0.2)',
                            borderWidth: 1
                        }
                    ]
                    
                };


                    this.options2= {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                steps: 10,
                                stepSize: 10,                                
                                responsive:true,

                                }
                            
                        }]
                    }
                };

                this.myStyles2={
                    height: '200px',
                    width: '100%',
                    position: 'relative',

                };
            },

            barFiscalYearData: function(earning,deduction,net,month){
                               

                this.barFiscalYearDatas={

                    labels: month,
                    datasets: [
                        {
                            label: 'Total Earnings',
                            data: earning,
                            
                            borderColor: 'rgba(147,195,218)',
                            backgroundColor:'rgba(147,195,218,0.5)',
                            borderWidth: 1
                        }, 
                        {
                            label: 'Total Deductions',
                            data:deduction,
                            
                            borderColor: 'rgba(255,0,0)',
                            backgroundColor:'rgba(255,0,0,0.5)',
                            borderWidth: 1
                        }, 
                        {
                            label: 'Net Salary',
                            data: net,
                            
                            borderColor: 'rgba(184,139,144)',
                            backgroundColor:'rgba(184,139,144,0.5)',
                            borderWidth: 1
                        }, 
                    ]
                    
                };

                

                this.options= {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                stepSize: 5000000,
                                responsive:true,
                                callback: function(value, index, values) {
                                    return Number(value).toLocaleString()  ;
                                }
                                
                                }
                            
                        }]
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, chartData)  {
                              
                                return Number(tooltipItem.value).toLocaleString();
                            },

                        }
                    }
                };

                this.myStyles={
                    height: '40%',
                    width: '100%',
                    position: 'relative',

                };
                
            },
            lineFiscalYearData: function(fixed,variable,month){
                               
                 this.linedDatas={

                    labels: month,
                    datasets: [
                        {
                            label: 'Total Fixed Pay',
                            data: fixed,
                            borderColor: 'rgba(143,154,222)',
                            backgroundColor:'rgba(255, 255, 255,0.1)',
                            borderWidth: 3
                        }, 
                        {
                            label: 'Total Variable Pay',
                            data:variable,
                            borderColor: 'rgba(149,223,215)',
                            backgroundColor:'rgba(255, 255, 255,0.1)',
                            borderWidth: 3
                        },
                       
                    ]
                    
                };

                

                this.options_line= {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                stepSize: 5000000,
                                responsive:true,
                                callback: function(value, index, values) {
                                    return Number(value).toLocaleString()  ;
                                }
                                
                                }
                            
                        }]
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, chartData)  {
                              
                                return Number(tooltipItem.value).toLocaleString();
                            },

                        }
                    }
                };

                this.myStyles={
                    height: '400px',
                    width: '100%',
                    position: 'relative',

                };
                
            },
            formatMoney: function(amount)
            {
                var money = Number(amount);
                money = money.toLocaleString();
                if(money=='NaN')
                money = amount;
                else{
                if(money.indexOf(".")<0)
                money = money+".00";
                }
                return money;
            },  

            lineJoiningData: function(fixed,variable,month,step_size){
                               
                 this.lineJoiningDatas={

                    labels: month,
                    datasets: [
                        {
                            label: 'Joiners',
                            data: fixed,
                            
                            borderColor: 'rgba(149,223,215)',
                            backgroundColor:'rgba(149,223,215,0.4)',
                            borderWidth: 3
                        }, 
                        {
                            label: 'Leavers',
                            data:variable,
                            
                            borderColor: 'rgba(143,154,222)',
                            backgroundColor:'rgba(143,154,222,0.4)',
                            borderWidth: 3
                        },
                       
                    ]
                    
                };

                this.joining_options_line= {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                steps: 10,
                                stepSize: 20,                              

                                }
                            
                        }]
                    }
                };

                this.myStyles={
                    height: '400px',
                    width: '100%',
                    position: 'relative',

                };
                
            },

            barDataOpposite(){
                this.barDatasOpposite={

                    labels:  ['Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing'],
                    datasets: [
                        {
                            label: 'Male',
                            data: [10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30],
                            
                            borderColor: 'rgba(77, 182, 172, 0.5)',
                            backgroundColor:'rgba(77, 182, 172, 0.2)',
                            borderWidth: 1
                        }, {
                            label: 'Female',
                            data: [-10,-20,-30,-10,-20,-30,-10,-20,-30,-10,-20,-30,-10,-20,-30,-10,-20,-30,-10,-20,-30,-10,-20,-30,-10,-20,-30,-10,-20,-30], 
                            borderColor: 'rgba(66, 133, 244, 0.5)',
                            backgroundColor:'rgba(66, 133, 244, 0.2)',
                            borderWidth: 1
                        }
                    ]
                    
                };

                    this.options3= {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                steps: 10,
                                stepSize: 20,                                
                                responsive:true,

                                }
                            
                        }]
                    }
                };

                this.myStyles3={
                    height: '200px',
                    width: '100%',
                    position: 'relative',

                };
            },

            polarData(){
                this.polarDatas = {
                  labels: [
                    'Red',
                    'Green',
                    'Yellow',
                    'Grey',
                    'Blue'
                  ],
                  datasets: [{
                    label: 'My First Dataset',
                    data: [11, 16, 7, 3, 14],
                    backgroundColor: [
                      'rgba(63, 81, 181, 0.5)',
                        'rgba(77, 182, 172, 0.5)',
                        'rgba(66, 133, 244, 0.5)',
                        'rgba(156, 39, 176, 0.5)',
                        'rgba(233, 30, 99, 0.5)',
                    ]
                  }]

                };
            },

            radarData(){
                this.radarDatas = {
                    labels: [
                        'Eating',
                        'Drinking',
                        'Sleeping',
                        'Designing',
                        'Coding',
                        'Cycling',
                        'Running'
                      ],
                      datasets: [{
                        label: 'My First Dataset',
                        data: [65, 59, 90, 81, 56, 55, 40],
                        fill: true,
                        backgroundColor: 'rgba(255, 99, 132, 0.2)',
                        borderColor: 'rgb(255, 99, 132)',
                        pointBackgroundColor: 'rgb(255, 99, 132)',
                        pointBorderColor: '#fff',
                        pointHoverBackgroundColor: '#fff',
                        pointHoverBorderColor: 'rgb(255, 99, 132)'
                      }, {
                        label: 'My Second Dataset',
                        data: [28, 48, 40, 19, 96, 27, 100],
                        fill: true,
                        backgroundColor: 'rgba(54, 162, 235, 0.2)',
                        borderColor: 'rgb(54, 162, 235)',
                        pointBackgroundColor: 'rgb(54, 162, 235)',
                        pointBorderColor: '#fff',
                        pointHoverBackgroundColor: '#fff',
                        pointHoverBorderColor: 'rgb(54, 162, 235)'
                      }]

                };
            },
            
            
            showSerch: function(){
                this.$bvModal.show('bv-modal-employeesearch');
            },
            getCompanyData:function() 
            {   
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/details' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){
                    
                    if(response.data.length != 0)
                    {
                        this.fdata = response.data;
                        this.company_id =  response.data.id;
                        this.logosrc = this.$api_url+'/images/company/' + response.data.logo;
                        
                        this.companyname =  response.data.name;
                        this.companyaddress =  response.data.address;
                        this.companycity =  response.data.city;
                        this.companyzip =  response.data.zip;
                        this.companyemployees =  response.data.no_of_employees;
                        this.activeemployees =  response.data.active_employees;
                        this.companyphone =  response.data.phone;
                        this.companyemail =  response.data.email;
                        this.companycontactperson =  response.data.contact_person;
                        
                        this.loan_settings =  response.data.loan_settings;

                        this.addons =  response.data.module_disabled;
                        if(this.addons.includes('LeaveAttendances'))
                        {
                            this.getHoliDays();
                        }
                        

                        if(response.data.no_of_employees == 0)
                            this.employee_err = true;
                        
                        if((response.data.tin == '') || (response.data.tax_zone == '') || (response.data.tax_circle == '')) 
                            this.overview_err = true;
                    

                        this.getAllEmployees();
                    }
                    else
                    {
                        
                    }                   
                    
                }.bind(this));


            },
            
            setCompany:function(x , y)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                let formData = new FormData();
                formData.append('company_id', x);
                axios.post(this.$api_url+'/company/setcompany', formData)
                                .then(function (response) 
                                {                                                                              
                                    window.location.href = this.$api_url+'/'+y;
                                    
                                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },


            getAllEmployees: function()
            {
                 if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/employee/companydirectory' , {
                    params: {
                        c_id:this.company_id
                    }
                }).then(function(response){
                    if(response.data)
                    {
                       
                        this.employees = response.data;
                                           
                    }                  
                    
                }.bind(this));
            },


            getpayrunsfiscalyear: function()
            {
  
                console.log('getpayrunsfiscalyear 0');
                axios.get(this.$api_url+'/list-payruns-fiscalyear/0' , {
                    params: {
                        
                  }
                }).then(function(response){
                    this.payrunsfiscalyear = response.data.data;
                    this.search.fiscal_year=this.payrunsfiscalyear[0].fiscal_year;
                    this.search_join.fiscal_year = this.payrunsfiscalyear[0].fiscal_year;
                    this.search_doughnut.fiscal_year=this.payrunsfiscalyear[0].fiscal_year;
                    this.getpayrunsapproved();
                    this.get_joiner_leaver_data();
                    this.get_fixed_variable_list_graph_data();

                }.bind(this));

                console.log('getpayrunsfiscalyear 1');
                console.log('search_doughnut');
                console.log(this.search_doughnut);
                axios.get(this.$api_url+'/list-payruns/1' , {
                    params: {
                        search_query: {type:'last_active'},                     
                    }
                }).then(function(response){


                    let payrunsapproveddoughnut2 = [];
                    payrunsapproveddoughnut2 = response.data.data;
                    let month = [];
                    let month_name =[];

                    

                    for (var i = 0; i < payrunsapproveddoughnut2.length; i++) { 
                        
                        var month_x = payrunsapproveddoughnut2[i]['month'].replaceAll(',', '');
                        if(month.indexOf(month_x) !== -1)  
                        {  
                            var inx = month.indexOf(month_x);
                        }   
                        else  
                        {  
                            month.push(payrunsapproveddoughnut2[i]['month'].replaceAll(',', ''));    
                        } 
                        
                        }



                    // for (let x in payrunsapproveddoughnut2) { 
                    //     console.log(x);
                         

                        
                    // } 
                    this.payrunsfiscalmonth = month;

                    this.search_doughnut.month = response.data.data[0].month;
                    this.getpayrunsapproveddoughnut();
                  }.bind(this));
                
                

            },


              seturlSearch: function()
              {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                var get_year = String(urlParams.get('fiscal_year'));
                var get_month = String(urlParams.get('month'));

                if(get_year=="" || get_year=='null')
                    this.search.fiscal_year="";
                else
                    this.search.fiscal_year=get_year;

                if(get_year=="" || get_year=='null')
                    this.search_doughnut.fiscal_year="";
                else
                    this.search_doughnut.fiscal_year=get_year;
                
                if(get_month=="" || get_month=='null')
                    this.search_doughnut.month="";
                else
                    this.search_doughnut.month=get_month;
                
                
              },

            setSearchJoin: function(pageflg)
              {
                  this.get_joiner_leaver_data();
              },

            setSearch: function(pageflg)
              {
                  this.getpayrunsapproved();
              },

            setSearchLineFixed: function(pageflg)
              {
                  this.get_fixed_variable_list_graph_data();
              },
              setSearchDoughnut: function(pageflg)
              {
                  this.getpayrunsapproveddoughnut();
              },

              //18-11-21

              get_joiner_leaver_data: function()
              { 
                  
         
                axios.get(this.$api_url+'/pyaroll-test' , {
                      params: {
                          
                          search_query: this.search_join,
                         
                      }
                }).then(function(response){
                    //this.search_join.fiscal_year = '';

                    this.joining_data = response.data;

                    let joining = [];
                    let joining_final = [];
                    let leaving = [];
                    let leaving_final = [];
                    let month = [];
                    let step = 0;

                    joining = this.joining_data.join_employee;

                    leaving = this.joining_data.leave_employee;
                    let ct = 0;

                    Object.keys(joining).forEach(function(key) {
                        

                        if(joining[key]>step)
                        {
                            step = joining[key];
                        }
                        month.push(key);
                        joining_final.push(joining[key]);

                        ct++;
                    });

                    ct = 0;
                    Object.keys(leaving).forEach(function(key) {
            
                        leaving_final.push(leaving[key]);

                        ct++;
                    });

                    
            
                    if(ct == 12 && step>0)
                    {
                        step = step * 2;
                        step = step/10;
                        
                        this.lineJoiningData(joining_final,leaving_final,month,step);
                    }
                    

                    
                
                  }.bind(this));
              },

            getpayrunsdraft: function()
              { 
                  this.search.type = '';
         
                axios.get(this.$api_url+'/list-all-payruns' , {
                      params: {
                          
                          search_query: this.search,
                         
                      }
                }).then(function(response){
                    this.payrunsdraft = response.data.data;

                    let total_earnings = [];
                    let deduction = [];
                    let net = [];
                    let gross = [];
                    let other = [];
                    let month = [];
                    let year = [];

                    for (let x in this.payrunsdraft) {
                        gross.push(parseFloat(this.payrunsdraft[x].earnings.replaceAll(',', '')));
                        other.push(parseFloat(this.payrunsdraft[x].additions.replaceAll(',', '')));
                        total_earnings.push(parseFloat(this.payrunsdraft[x].total_earnings.replaceAll(',', '')));
                        deduction.push(parseFloat(this.payrunsdraft[x].deductions.replaceAll(',', '')));
                        net.push(parseFloat(this.payrunsdraft[x].total_pay.replaceAll(',', '')));
                        month.push(this.payrunsdraft[x].month.replaceAll(',', ''));
                        year.push(this.payrunsdraft[x].year);
                      

                    } 


                    this.draft_payruns.total_earnings = total_earnings;
                    this.draft_payruns.deduction = deduction;
                    this.draft_payruns.gross = gross;
                    this.draft_payruns.other = other;
                    this.draft_payruns.net = net;
                    this.draft_payruns.month = month;
                    this.draft_payruns.year = year;

               
                  }.bind(this));
              },

            getpayrunsapproved: function()
              {

                
                  this.quick_start_load = true;
                  console.log('getpayrunsapproved 0');
                axios.get(this.$api_url+'/list-payruns/1' , {
                    params: {
                        search_query: this.search,
                      
                    }
                }).then(function(response){
                        this.payrunsapproved = response.data.data;

                        let total_earnings = [];
                        let deduction = [];
                        let net = [];
                        let month = [];
                        let year = [];

                        

                        for (let x in this.payrunsapproved) {

                            let total_earnings_draft = 0;
                            let deduction_draft = 0;
                            let net_draft = 0;
                            

                            for (let y in this.draft_payruns.year) {
                                if(this.draft_payruns.year[y] == this.payrunsapproved[x].year && this.draft_payruns.month[y] == this.payrunsapproved[x].month){
                                    total_earnings_draft = total_earnings_draft + this.draft_payruns.total_earnings[y] ;
                                    deduction_draft = deduction_draft + this.draft_payruns.deduction[y] ;
                                    net_draft = net_draft + this.draft_payruns.net[y] ;
                                    
                                }

                            }

                            total_earnings_draft = total_earnings_draft + parseFloat(this.payrunsapproved[x].total_earnings.replaceAll(',', ''));
                            deduction_draft = deduction_draft + parseFloat(this.payrunsapproved[x].deductions.replaceAll(',', ''));
                            net_draft = net_draft + parseFloat(this.payrunsapproved[x].total_pay.replaceAll(',', ''));


                          

                          var month_x = this.payrunsapproved[x].month.replaceAll(',', '');
                            if(month.indexOf(month_x) !== -1)  
                            {  
                                var inx = month.indexOf(month_x);
                                total_earnings[inx] = total_earnings[inx] +total_earnings_draft;
                                deduction[inx] = deduction[inx] +deduction_draft;
                                net[inx] = net[inx] +net_draft;

                            }   
                            else  
                            {  
                                month.push(this.payrunsapproved[x].month.replaceAll(',', ''));
                                total_earnings.push(total_earnings_draft);
                                deduction.push(deduction_draft);
                                net.push(net_draft);
                                year.push(this.payrunsapproved[x].year);
                            }  
                            /*total_earnings.push(total_earnings_draft);
                            deduction.push(deduction_draft);
                            net.push(net_draft);

                            month.push(this.payrunsapproved[x].month.replaceAll(',', ''));
                            year.push(this.payrunsapproved[x].year);*/

                        } 


                        month.reverse();
                        total_earnings.reverse();
                        deduction.reverse();
                        net.reverse();
                        year.reverse();
                        

                         
                        
                        this.barFiscalYearData(total_earnings,deduction,net,month);

                        this.quick_start_load = false;
                        
                        
          
                  }.bind(this));


              },


              get_fixed_variable_list_graph_data: function()
              {
                this.search.type = 'line_fixed';
                console.log('get_fixed_variable_list_graph_data 0');
                axios.get(this.$api_url+'/list-payruns/1' , {
                    params: {
                        search_query: this.search,
                      
                    }
                }).then(function(response){

                        this.search.type = ''; 
                        
                        this.payrunsapproved = response.data.data;

                        let fixed_payment = [];
                        let variable_payment = [];
                        let net = [];
                        let month = [];
                        let year = [];

                        

                        for (let x in this.payrunsapproved) {

                           
                            let month_year = '';
                          

                          var month_x = this.payrunsapproved[x].month.replaceAll(',', '') +'-'+this.payrunsapproved[x].year;

                            
                            if(month.indexOf(month_x) !== -1)  
                            { 
                                var inx = month.indexOf(month_x);  
                               
                                fixed_payment[inx] =  fixed_payment[inx] + parseFloat(this.payrunsapproved[x].fixed_payment.replaceAll(',', ''));
                                variable_payment[inx] = variable_payment[inx] + parseFloat(this.payrunsapproved[x].variable_payment.replaceAll(',', ''));

                            }   

                            else
                            {
                                month_year = this.payrunsapproved[x].month.replaceAll(',', '') +'-'+this.payrunsapproved[x].year;
                                month.push(month_year);
                                fixed_payment.push(parseFloat(this.payrunsapproved[x].fixed_payment.replaceAll(',', '')));
                                variable_payment.push(parseFloat(this.payrunsapproved[x].variable_payment.replaceAll(',', '')));
                                
                            }
                            

                        } 

                        month.reverse();
                        fixed_payment.reverse();
                        variable_payment.reverse();
       
                        this.lineFiscalYearData(fixed_payment,variable_payment,month);

                        //this.search.type = '';
                        
                        
          
                  }.bind(this));


              },

              getpayrunsapproveddoughnut: function()
              {
                let year = '';
                let month = '';
                
                if(this.search_doughnut.fiscal_year==''){
           
                    console.log('getpayrunsapproveddoughnut 0');
                    axios.get(this.$api_url+'/list-payruns-fiscalyear/0' , {
                    params: {
                        
                      } 
                    }).then(function(response){

                        year = response.data.data[0].fiscal_year;
                        month = this.search_doughnut.month;

                        var yr=year.split("-"); //at_edit
                        this.year_segment1=yr[0];
                        this.year_segment2=yr[1];
                        console.log('getpayrunsapproveddoughnut 1');
                        axios.get(this.$api_url+'/list-payruns/1' , {
                            params: {
                                search_query: { fiscal_year:year,month:month},
                              
                            }
                        }).then(function(response){
                                this.payrunsapproveddoughnut2 = response.data.data;
                                this.doughnut_length = this.payrunsapproveddoughnut2.length;

                          }.bind(this));
                         
                    }.bind(this));
                }

                console.log('getpayrunsapproveddoughnut 2');
                this.doughnut_loader = true;
                this.search_doughnut.type = 'pie_chart';
                console.log(this.search_doughnut.type);
                axios.get(this.$api_url+'/list-payruns/1' , {
                    params: {
                        search_query: this.search_doughnut,
                      
                    }
                }).then(function(response){
                        this.payrunsapproveddoughnut = response.data.data;
                        //console.log(this.payrunsapproveddoughnut.length);
                        this.search_doughnut.type = '';

                       
                        

                        var a = 0;
                        var b = 0;
                        var c = 0;
                        var d = 0;
                        var e = 0;
                        var f = 0;

                        console.log('payrunsapproveddoughnut length');
                        console.log(this.payrunsapproveddoughnut.length);


                        if(this.payrunsapproveddoughnut.length > 0 ){   ///&& this.payrunsapproveddoughnut.length < this.doughnut_length
                            var mon = this.payrunsapproveddoughnut[0].month;
                            var yea = this.payrunsapproveddoughnut[0].year;
                            for (let y in this.payrunsapproveddoughnut) {
                                if(this.payrunsapproveddoughnut[y].month == mon && this.payrunsapproveddoughnut[y].year == yea ){
                                    a = a + parseFloat(this.payrunsapproveddoughnut[y].basic_salary.replaceAll(',', ''));
                                    b = b + parseFloat(this.payrunsapproveddoughnut[y].house_rent.replaceAll(',', ''));
                                    c = c + parseFloat(this.payrunsapproveddoughnut[y].conveyance_allowance.replaceAll(',', ''));
                                    d = d + parseFloat(this.payrunsapproveddoughnut[y].medical_allowance.replaceAll(',', ''));
                                    e = e + parseFloat(this.payrunsapproveddoughnut[y].total_additions.replaceAll(',', ''));
                                    f = f + parseFloat(this.payrunsapproveddoughnut[y].pf_contribution.replaceAll(',', ''));
                                }
                               
                            }


                            let basic_salary = a;
                            let house_rent =  b;
                            let conveyance_allowance =  c;
                            let medical_allowance=  d;
                            let total_additions =   e;      
                            let pf_contribution =  f;  
                            
                            // console.log('basic_salary');
                            // console.log(basic_salary);

                            // console.log('house_rent');
                            // console.log(house_rent);

                            // console.log('conveyance_allowance');
                            // console.log(conveyance_allowance);

                            // console.log('medical_allowance');
                            // console.log(medical_allowance);

                            // console.log('total_additions');
                            // console.log(total_additions);

                            // console.log('pf_contribution');
                            // console.log(pf_contribution);

                            

                            this.doughnutData(basic_salary,house_rent,conveyance_allowance,medical_allowance,total_additions,pf_contribution);

                        }
                        else{

                        //     let gross = gross_draft + parseFloat(this.payrunsapproveddoughnut[0].earnings.replaceAll(',', ''));
                        //     let other_allowenecs = other_draft + parseFloat(this.payrunsapproveddoughnut[0].additions.replaceAll(',', ''));
                        //     let total = total_earnings_draft + parseFloat(this.payrunsapproveddoughnut[0].total_earnings.replaceAll(',', ''));
                        //     let deduction= deduction_draft + parseFloat(this.payrunsapproveddoughnut[0].deductions.replaceAll(',', ''));
                        //     let net = net_draft + parseFloat(this.payrunsapproveddoughnut[0].total_pay.replaceAll(',', ''));

                        // this.doughnutData(gross,other_allowenecs,total,deduction,net);
                            
                        }

                        this.doughnut_loader = false;

                        /*let gross = gross_draft + parseFloat(this.payrunsapproveddoughnut[0].earnings.replaceAll(',', ''));
                        let other_allowenecs = other_draft + parseFloat(this.payrunsapproveddoughnut[0].additions.replaceAll(',', ''));
                        let total = total_earnings_draft + parseFloat(this.payrunsapproveddoughnut[0].total_earnings.replaceAll(',', ''));
                        let deduction= deduction_draft + parseFloat(this.payrunsapproveddoughnut[0].deductions.replaceAll(',', ''));
                        let net = net_draft + parseFloat(this.payrunsapproveddoughnut[0].total_pay.replaceAll(',', ''));*/             

                        
                        
         
                  }.bind(this));



              },

              dashboardtotal: function()
              {
               axios.get(this.$api_url+'/dashboard_total' , {
                    params: {
                      
                    }
                }).then(function(response){
                        this.dashboardTotals = response.data;

                        
                       
                  }.bind(this));
              },

        },
        created: function(){
            
            this.getCompanyData(); 
            this.dashboardtotal();  
            // this.fillData();   
            // this.barData();
            // this.barDataOpposite();
            // this.polarData();
            // this.radarData();
            // this.getpayrunsfiscalyear();
            // this.seturlSearch();
            
            // this.getpayrunsdraft();
            


        }
    }



</script>
<style scoped>
.employee-count {
	font-size: 2.26rem;
}
.trz_loader img {
	margin: 0;
	margin: 20px;
}

.trz_loader {
	width: 100%;
	text-align: center;
}

.dash-payroll-info-abs {
	position: absolute;
	/* right: ; */
	bottom: -17px;
	font-size: 12px;
	right: 0;
}
.dash-widget-info.float-right.trz_relative {
	position: relative;
}
.dash-widget-info.float-right.dash-second {
	margin-right: 10px;
}
.dashboard-card4 {
	width: 33%;
}
.dashboard-card3 {
	width: 22%;
}
.img_abs_2 {
	position: absolute;
	/* width: unset !important; */
	width: 12% !important;
}
.img_abs {
	width: ;
	position: absolute;
	width: 16% !important;
}
.lock-icon-trz-dash {
	margin-top: -5px;
}
.lock-icon-trz-tab-dash {
	position: absolute;
	right: 5px;
	top: 5px;
	font-size: 20px !important;
}

 
@media only screen and (max-width: 1600px) {
.dashboard-card4 {
	width: 50%;
} 
.img_abs_2 {
	width: 9% !important;
}

.dashboard-card3 {
	width: 33.3%;
}

.img_abs {
	width: 14% !important;
} 
.col-sm-1.float-left.text-center.holiday_date {
	font-size: 20px !important;
}
}

@media only screen and (max-width: 1350px) {
.col-sm-1.float-left.text-center.holiday_date {
	font-size: 15px !important;
}
}
</style>